import { render, staticRenderFns } from "./Folder.vue?vue&type=template&id=457e6206&scoped=true"
import script from "./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue?vue&type=script&lang=js"
import style0 from "./Folder.vue?vue&type=style&index=0&id=457e6206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457e6206",
  null
  
)

export default component.exports